import type { ResourceId } from 'framework/crud';
import {
  CustomHtmlTagHelperDependenciesProvider,
  useCustomHtmlTagHelperDependencies,
} from 'infrastructure/textTransformer/customHtmlTagsHelper/dependencies';
import { useMemo } from 'react';

type EmployeeTimelineHtmlTagDependenciesProps = {
  employeeId: string;
  children: React.ReactNode;
};

const EmployeeTimelineHtmlTagDependencies = ({ employeeId, children }: EmployeeTimelineHtmlTagDependenciesProps) => {
  const customHtmlTagDependencies = useCustomHtmlTagHelperDependencies();

  const localCustomHtmlTagDependencies = useMemo(
    () => ({
      ...customHtmlTagDependencies,
      getEmployeeOfferUrl: (offerId: ResourceId) => `/workers/${employeeId}/offers/${offerId}`,
    }),
    [customHtmlTagDependencies, employeeId],
  );

  return (
    <CustomHtmlTagHelperDependenciesProvider value={localCustomHtmlTagDependencies}>
      {children}
    </CustomHtmlTagHelperDependenciesProvider>
  );
};

export default EmployeeTimelineHtmlTagDependencies;
